import React, { useEffect } from "react";
import { Link } from "react-router-dom";

type Props = {
  open: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
};

export default function ComingSoonModal({
  open,
  onClose,
  title = "Coming Soon",
  message = "We’re crafting a seamless launch experience for creators and collectors. Not live yet—but it’s close. Stay tuned 🚀",
}: Props) {
  // ESC + lock scroll
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = original;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div
        className="bg-black/50 absolute inset-0 backdrop-blur-[2px]"
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        className="relative z-[101] w-[92%] max-w-sm rounded-2xl bg-white p-6 text-center shadow-2xl dark:bg-jacarta-800"
      >
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-accent/15">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            className="fill-accent"
          >
            <path d="M12 2l10 19H2L12 2zm1 14h-2v2h2v-2zm0-6h-2v5h2V10z" />
          </svg>
        </div>
        <h3 className="font-display text-xl text-jacarta-700 dark:text-white">
          {title}
        </h3>
        <p className="mt-2 text-sm text-jacarta-500 dark:text-jacarta-300">
          {message}
        </p>

        <div className="mt-6 flex items-center justify-center gap-3">
          <Link
            to="/"
            className="rounded-md bg-accent px-4 py-2 font-semibold text-white hover:bg-accent-dark"
          >
            Back to Home{" "}
          </Link>
          <Link
            to="/collections"
            className="rounded-md border border-jacarta-200 px-4 py-2 text-jacarta-700 hover:bg-jacarta-50 dark:border-jacarta-600 dark:text-white dark:hover:bg-jacarta-700/60"
          >
            Explore Collections
          </Link>
        </div>
      </div>
    </div>
  );
}
